/**
 * FP3-044 Phase A — Admin Sessions summary (counts only, MVP).
 *
 * Row-by-row view is reachable through the provider drill-in (the
 * existing /students/:id?as_provider=<pid> Sessions tab is already
 * read-only for admin family).
 */
import { Card } from "@/components/ui/card";

export default function AdminSessionsSummary({ summary, expanded = false }) {
  const s = summary || {
    completed_last_30d: 0,
    cancelled_last_30d: 0,
    make_up_needed_last_30d: 0,
    upcoming_next_7d: 0,
  };
  return (
    <Card className="p-5 bg-white border-[#E5E3DB]" data-testid="admin-sessions-summary">
      <div className="flex items-center justify-between mb-3">
        <p className="text-[13px] font-medium text-[#1F2937]">Sessions</p>
        <p className="text-[10.5px] text-[#6B7280]">
          {s.window_start || ""} → {s.window_end || ""}
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <Stat label="Completed (30d)" value={s.completed_last_30d} testid="admin-sessions-completed" />
        <Stat label="Cancelled (30d)" value={s.cancelled_last_30d} testid="admin-sessions-cancelled" />
        <Stat label="Make-up needed" value={s.make_up_needed_last_30d} testid="admin-sessions-makeup" />
        <Stat label="Upcoming (7d)" value={s.upcoming_next_7d} testid="admin-sessions-upcoming" />
      </div>
      {expanded && (
        <p className="mt-4 text-[11px] text-[#6B7280] italic">
          For session-by-session detail and notes, open any provider above and
          switch to their Sessions tab in the read-only workspace.
        </p>
      )}
    </Card>
  );
}

function Stat({ label, value, testid }) {
  return (
    <div className="border border-[#E5E3DB] rounded-md p-3">
      <p className="text-[10.5px] uppercase tracking-wide text-[#6B7280]">{label}</p>
      <p data-testid={testid} className="text-[20px] font-semibold text-[#1F2937] tabular-nums">
        {value ?? 0}
      </p>
    </div>
  );
}
